import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export interface ParentOnboardingData {
  studentNumber: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  relationship: string;
}

export interface LoginData {
  phoneNumber: string;
  studentNumber: string;
  sessionId: string;
}

export interface OtpRequestData {
  otp: string;
  sessionId: string;
}

export interface ParentOtpContact {
  id: string;
  channel: 'sms' | 'whatsapp' | 'email';
  maskedValue: string;
  recommended: boolean;
}

export interface ParentLoginResponse {
  success: boolean;
  message: string;
  nextStep: 'SELECT_OTP_DESTINATION';
  contacts: ParentOtpContact[];
}

export interface ParentSendOtpRequest {
  sessionId: string;
  contactId: string;
}

export interface ParentSendOtpResponse {
  success: boolean;
  nextStep: 'CONFIRM_OTP';
  destination: {
    channel: 'sms' | 'whatsapp' | 'email';
    maskedValue: string;
  };
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  endpoints: builder => ({
    login: builder.mutation<ParentLoginResponse, LoginData>({
      query: data => ({
        url: '/parent/login',
        method: 'POST',
        body: data,
      }),
    }),
    sendOtp: builder.mutation<ParentSendOtpResponse, ParentSendOtpRequest>({
      query: data => ({
        url: '/parent/login/otp/send',
        method: 'POST',
        body: data,
      }),
    }),
    verifyOtp: builder.mutation<any, OtpRequestData>({
      query: data => ({
        url: '/parent/login/otp/confirm',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
} = authApi;
